import axios, { AxiosResponse } from "axios"
import { InsertEtiquetaCommandProps } from "./Commands/InsertEtiquetaCommand"
import { UpdateEtiquetaCommandProps } from "./Commands/UpdateEtiquetaCommand"
import { GetAllEtiquetasDtoIPagedEnumerableProps } from "./DTOs/GetAllEtiquetasDtoIPAgedEnumerable"
import { GetEtiquetaByIdDtoProps } from "./DTOs/GetEtiquetaByIdDto"
import { etiquetaByIdAdapter, etiquetaDTOAdapter } from "./Etiqueta.adapter"

export interface GetEtiquetasEmpresaQueryParamsProps {
  Keyword?: string
  SortingCriteria: string
  IsEnabled?: boolean
  MaxResultCount?: number | string
  SkipCount?: number | string
}

export async function getEtiquetasEmpresa(
  queryParams?: GetEtiquetasEmpresaQueryParamsProps
) {
  const { data }: Record<"data", GetAllEtiquetasDtoIPagedEnumerableProps> =
    await axios.get("/Etiqueta", {
      params: queryParams,
    })
  return {
    currentPage: data?.currentPage,
    items: data?.items?.map((categoria) => etiquetaDTOAdapter(categoria)),
    totalCount: data?.totalCount,
  }
}

export async function getEtiquetaEmpresaById(
  id: string
): Promise<GetEtiquetaByIdDtoProps> {
  const { data }: { data: GetEtiquetaByIdDtoProps } = await axios.get(
    `/Etiqueta/${id}`
  )
  return etiquetaByIdAdapter(data)
}

export async function postEtiquetaEmpresa(
  newCategory: InsertEtiquetaCommandProps
): Promise<AxiosResponse> {
  const resp = await axios.post("/Etiqueta", newCategory)
  return resp
}

export async function deleteEtiquetaEmpresaById(
  id: string
): Promise<AxiosResponse> {
  return axios.delete(`/Etiqueta/${id}`)
}

export async function putEtiquetaEmpresa(
  editedCategory: UpdateEtiquetaCommandProps
): Promise<UpdateEtiquetaCommandProps> {
  return axios.put(`/Etiqueta/${editedCategory.id}`, editedCategory)
}
